import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import GlobalToast from './GlobalToast';
import styles from './globaltoastcontainer.scss';

const globalToastContainerClassName = styles.globalToastContainerClassName.replace(/"/g, '');

export default class GlobalToastContainer extends Component {
    /**
     * TODO: support lowerLeft, lowerRight to add toasts upward
     */
    static propTypes = {
        position: PropTypes.oneOf(['upperLeft', 'upperRight']),
        toasts: PropTypes.array,
        xOffset: PropTypes.number,
        yOffset: PropTypes.number,
        targetId: PropTypes.string,
        className: PropTypes.string,
    }

    static defaultProps = {
        position: 'upperRight',
        xOffset: 0,
        yOffset: 0,
    }

    _coordinateAdjustor = () => {
        const { xOffset, yOffset, position } = this.props;
        const result = {};
        switch (position) {
        case 'upperLeft':
            result.left = xOffset;
            result.top = yOffset;
            break;
        case 'upperRight':
            result.right = xOffset;
            result.top = yOffset;
            break;
        default:
            break;
        }
        return result;
    }

    render() {
        const coordinate = this._coordinateAdjustor();
        const { className, targetId, toasts } = this.props;
        return (createPortal(
            <div style={{ ...coordinate }} className={ `${globalToastContainerClassName} ${className}` }>
                {toasts && toasts.map(toastProp => <GlobalToast { ...toastProp } />)}
            </div>,
            document.getElementById(targetId) || document.body,
        ));
    }
}